import Base from 'base.service';

export default class Attachments extends Base {
  constructor ($http, Upload, $cookies) {
    'ngInject';

    super($http);
    this.Upload = Upload;
    this.token = $cookies.get('token');
  }

  create(attachment) {
    return this.Upload
      .upload({
        url: this.apiUrl + '/pingsta/attachments.json',
        data: attachment,
      })
      .then(response => response.data.attachment);
  }

  destroy(attachment_id) {
    return this.$http.post(`${this.apiUrl}/pingsta/attachments/${attachment_id}/destroy.json`);
  }

  download(attachment_id) {
    location.href = `${this.apiUrl}/pingsta/attachments/${attachment_id}/download.json?access_token=${this.token}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/util/attachments.service.js